import { createI18n } from 'vue-i18n'
import fr from './fr'
import en from './en'
import pt from './pt'

// Get the language saved in localStorage or use the default one
const savedLanguage = localStorage.getItem('selectedLanguage');
// Temporarily, if the saved language is PT, use FR as the default
const defaultLocale = savedLanguage
  ? (savedLanguage.toLowerCase() === 'pt' ? 'fr' : savedLanguage.toLowerCase())
  : 'fr';

export default createI18n({
  legacy: false,
  locale: defaultLocale, // saved or default language
  fallbackLocale: 'en', // idioma de fallback
  messages: {
    fr,
    en,
    pt
  }
})